
import { alertActions } from "./alert.actions";
import {
  APIcallFunction,
  headerForPrivateAPI,
} from "../_helpers";
import { coinManagementConstant } from "../_constants/coinManagement.constant";

export const coinManagementActions = {
  tokenManagementList,
  addCoinManagement,
  updateCoinManagement,
  deleteCoinManagement,
  updateTokenManagement,
  addAPiKey,
  getTransactionHistory,
  buyPkrdHistory,
  getAmountAndCount, getBuyPkrdDetails,getAllFiatCurrency
};

//get
function tokenManagementList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/coin/getCoinList",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (coin) => {
        dispatch(success(coin));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(coin) {
    return { type: coinManagementConstant.GET_COIN_LIST_REQUEST, coin };
  }
  function success(coin) {
    return { type: coinManagementConstant.GET_COIN_LIST_SUCCESS, coin };
  }
  function failure(error) {
    return {
      type: coinManagementConstant.GET_COIN_LIST_FAILURE,
      error,
    };
  }
}

//add
function addCoinManagement(data, ref) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/coin/createCoin",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //window refresh
        dispatch(coinManagementActions.tokenManagementList(ref))
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: coinManagementConstant.CREATE_COIN_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: coinManagementConstant.CREATE_COIN_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: coinManagementConstant.CREATE_COIN_LIST_FAILURE,
      error,
    };
  }
}

//update
function updateCoinManagement(data, updatedCoin) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/coin/updateCoin",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        dispatch(coinManagementActions.tokenManagementList(data, updatedCoin));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: coinManagementConstant.UPDATE_COIN_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: coinManagementConstant.UPDATE_COIN_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: coinManagementConstant.UPDATE_COIN_FAILURE,
      error,
    };
  }
}

//delete
function deleteCoinManagement(data, listData) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/coin/deleteCoin",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        dispatch(coinManagementActions.tokenManagementList(listData));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: coinManagementConstant.DELETE_COIN_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: coinManagementConstant.DELETE_COIN_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: coinManagementConstant.DELETE_COIN_FAILURE,
      error,
    };
  }
}

function updateTokenManagement(data, reaData) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/coin/updateCoinStatus",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        dispatch(coinManagementActions.tokenManagementList(data, reaData));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: coinManagementConstant.UPDATE_COIN_STATUS_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: coinManagementConstant.UPDATE_COIN_STATUS_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: coinManagementConstant.UPDATE_COIN_STATUS_FAILURE,
      error,
    };
  }
}


//add
function addAPiKey(data, ref) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/coin/addApiKeyInCoin",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //window refresh
        // dispatch(coinManagementActions.tokenManagementList(ref))
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: coinManagementConstant.CREATE_APIKEY_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: coinManagementConstant.CREATE_APIKEY_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: coinManagementConstant.CREATE_APIKEY_FAILURE,
      error,
    };
  }
}



function getTransactionHistory(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/transaction/getTransactionHistory",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (coin) => {
        dispatch(success(coin));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(coin) {
    return { type: coinManagementConstant.GET_HISTORY_LIST_REQUEST, coin };
  }
  function success(coin) {
    return { type: coinManagementConstant.GET_HISTORY_LIST_SUCCESS, coin };
  }
  function failure(error) {
    return {
      type: coinManagementConstant.GET_HISTORY_LIST_FAILURE,
      error,
    };
  }
}


function buyPkrdHistory(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/express/buyPkrdHistory",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (coin) => {
        dispatch(success(coin));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(coin) {
    return { type: coinManagementConstant.GET_PKRD_HISTORY_LIST_REQUEST, coin };
  }
  function success(coin) {
    return { type: coinManagementConstant.GET_PKRD_HISTORY_LIST_SUCCESS, coin };
  }
  function failure(error) {
    return {
      type: coinManagementConstant.GET_PKRD_HISTORY_LIST_FAILURE,
      error,
    };
  }
}



function getAmountAndCount(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/transaction/getAmountAndCount ",
  };
  return APIcallFunction(credentials)
}


function getBuyPkrdDetails(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/express/getBuyPkrdDetails ",
  };
  return APIcallFunction(credentials)
}




function getAllFiatCurrency(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/fiatCurrency/getAllFiatCurrency",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (coin) => {
        dispatch(success(coin));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(coin) {
    return { type: coinManagementConstant.GET_ALL_FIAT_CURRENCY_LIST_REQUEST, coin };
  }
  function success(coin) {
    return { type: coinManagementConstant.GET_ALL_FIAT_CURRENCY_LIST_SUCCESS, coin };
  }
  function failure(error) {
    return {
      type: coinManagementConstant.GET_ALL_FIAT_CURRENCY_LIST_FAILURE, error,
    };
  }
}